import { render, staticRenderFns } from "./TrainingEventFormModal.vue?vue&type=template&id=8fce9a0e"
import script from "./TrainingEventFormModal.vue?vue&type=script&lang=js"
export * from "./TrainingEventFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports